module.exports = __webpack_public_path__ + "img/farm_Honduras.b7bfe011.jpg";